module.exports = __webpack_public_path__ + "img/SEJ_Eventos_QR.743c45df.svg";